"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentTerminalControlCachedPaymentSerialization = void 0;
const PaymentTerminalControlPaymentWithPayloadSerialization_1 = require("./PaymentTerminalControlPaymentWithPayloadSerialization");
class PaymentTerminalControlCachedPaymentSerialization {
    static serialize(entity) {
        const copy = { ...entity };
        copy.cached_payment = entity.cached_payment
            ? JSON.parse(PaymentTerminalControlPaymentWithPayloadSerialization_1.PaymentTerminalControlPaymentWithPayloadSerialization.serialize(entity.cached_payment))
            : undefined;
        return JSON.stringify(copy);
    }
    static deserialize(msg) {
        const entity = JSON.parse(msg);
        const copy = { ...entity };
        copy.cached_payment = entity.cached_payment
            ? PaymentTerminalControlPaymentWithPayloadSerialization_1.PaymentTerminalControlPaymentWithPayloadSerialization.deserialize(JSON.stringify(entity.cached_payment))
            : undefined;
        return copy;
    }
}
exports.PaymentTerminalControlCachedPaymentSerialization = PaymentTerminalControlCachedPaymentSerialization;
